<template>
    <el-result title="404" sub-title="chart">
        <template #icon>
            <el-image style="width:222px;height:222px"
            src="/Qwe.VueComponent/Image/404.png"
            ></el-image>
        </template>
        <template #extra>
            <el-button type="primary">返回</el-button>
        </template>
    </el-result>
</template>

<script>
    export default{
        name:"Chart",
        data:function(){
            return {}
        }
    }
</script>